import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";

const CardProject = ({ project, onClick }) => {
  return (
    <Card
      onClick={() => onClick(project)}
      sx={{
        width: { xs: "90%", sm: 280, md: 300 },
        minHeight: 320,
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: 4,
        boxShadow: 4,
        cursor: "pointer",
        transition: "transform 0.3s ease, boxShadow 0.3s ease",
        backgroundColor: "background.paper",
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: 6,
        },
      }}
    >
      <CardMedia
        component="img"
        height="160"
        image={project.thumb}
        alt={project.title}
        sx={{
          objectFit: "cover",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      />
      <CardContent sx={{ px: 2, py: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {project.title}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mt: 1,
            minHeight: "60px",
            fontSize: "0.9rem",
          }}
        >
          {project.description}
        </Typography>

        <Stack
          direction="row"
          spacing={1}
          sx={{ mt: 2, flexWrap: "wrap", justifyContent: "start" }}
        >
          {project.technologies.map((TechIcon, index) => (
            <Box
              key={index}
              sx={{
                width: 26,
                height: 26,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "text.primary",
              }}
            >
              <TechIcon fontSize="small" />
            </Box>
          ))}
        </Stack>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
          }}
        >
          {project.title !== "Notas Móvil" && (
            <IconButton
              component="a"
              href={project.demoUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "text.primary" }}
              onClick={(e) => e.stopPropagation()}
            >
              <LanguageIcon />
            </IconButton>
          )}

          <IconButton
            component="a"
            href={project.girhubUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "text.primary" }}
            onClick={(e) => e.stopPropagation()}
          >
            <GitHubIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardProject;
